import { AbstractDimension, frAupaSelectedDimension } from '@orus.eu/dimensions'
import type { FrAupaQuote } from '@orus.eu/pricing'
import { quoteV3ToSerializedQuoteData } from '@orus.eu/pricing'
import type { Result } from '@orus.eu/result'

export type FrAupaQuoteFailure = { type: 'zipcode-not-rated' }
export type FrAupaQuoteResult = Result<FrAupaQuote, FrAupaQuoteFailure>

export class FrAupaQuoteDimension<NAME extends string> extends AbstractDimension<NAME, FrAupaQuoteResult> {
  override formatToString(value: FrAupaQuoteResult): string {
    if (value.type === 'failure') {
      return `NULL - ${value.problem.type}`
    }
    return quoteV3ToSerializedQuoteData(value.output)
  }
}

export const frAupaQuoteDimension = new FrAupaQuoteDimension({
  name: 'frAupaQuote',
  displayKeys: { name: 'dimension_name_fr_aupa_quote' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: {
    lockedInQuoteFor: {
      client: frAupaSelectedDimension,
    },
  },
} as const)
